import { Button, DatePicker, Form, Table, Tabs, Typography } from 'antd';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import { addDays, format, formatDate, subDays } from 'date-fns';
import { useEffect, useState } from 'react';
import { get_customer_overview, get_customer_overview_per_dau } from 'services/AnalyzeCustomerBase';
import { useDispatch } from 'react-redux';
import { setAppLoading } from 'app/slices/appSlice';

const { RangePicker } = DatePicker;
dayjs.extend(customParseFormat);

function CustormersOverview() {
    const now = new Date();
    const [columns, set_columns] = useState([
        {
            title: 'Cột',
            dataIndex: 'column',
        },
        {
            title: 'Tên hiển thị tiếng anh',
            dataIndex: 'engShow',
        },
        {
            title: 'Giá trị',
            dataIndex: 'value',
        },
    ]);

    const [columnsForPerDAU, set_columns_for_per_dau] = useState([
        {
            title: 'Cột',
            dataIndex: 'column',
        },
        {
            title: 'Tên hiển thị tiếng anh',
            dataIndex: 'engShow',
        },
        {
            title: 'Giá trị',
            dataIndex: 'value',
        },
    ]);

    const dispatch = useDispatch();

    const [all_customers, set_all_customers] = useState([]);
    const [all_customers_per_dau, set_all_customers_per_dau] = useState([]);
    const [currentTime, set_currentTime] = useState({
        startTime: format(subDays(now, 30), 'dd/MM/yyyy'),
        endTime: format(now, 'dd/MM/yyyy'),
    });
    const defaultTime = {
        startTime: dayjs(formatDate(subDays(now, 30), 'yyyy/MM/dd')),
        endTime: dayjs(formatDate(now, 'yyyy/MM/dd')),
    };

    const [isOpen, set_open] = useState(false);
    function onOpenChange(open) {
        set_open(open);
    }

    function onCalendarChange(dates) {
        let obj = Object.assign({}, before_data);
        obj.startTime = dayjs(dates[0]).format('DD/MM/YYYY');
        obj.endTime = dayjs(dates[1]).format('DD/MM/YYYY');

        if (open == true) {
            set_before_data(obj);
        }
    }

    useEffect(() => {
        async function Refresh(isLoad) {
            try {
                dispatch(setAppLoading(true));
                const [allCustomersOverviewResponse, allCustomersPerDAUOverviewResponse] =
                    await Promise.all([
                        get_customer_overview(currentTime),
                        get_customer_overview_per_dau(currentTime),
                    ]);
                const allCustomersOverview = allCustomersOverviewResponse?.data?.data;
                const allCustomersPerDAUOverview = allCustomersPerDAUOverviewResponse?.data?.data;
                const columnstmp = Object.keys(allCustomersOverview[0] || {}).map((key) => {
                    const { engShow, column } = allCustomersOverview[0][key];
                    return { title: engShow, dataIndex: column, width: 150 };
                });
                const columnstmpForPerDAU = Object.keys(allCustomersPerDAUOverview[0] || {}).map((key) => {
                    const { engShow, column } = allCustomersPerDAUOverview[0][key];
                    return { title: engShow, dataIndex: column, width: 150 };
                });

                set_columns(columnstmp);
                set_columns_for_per_dau(columnstmpForPerDAU);

                let allCustomersRowData = [];
                let allCustomersPerDAURowData = [];
                for (let i = 0; i < allCustomersOverview.length; i++) {
                    const objColumnValue = allCustomersOverview[i].reduce((acc, item) => {
                        acc[item.column] = item.value;
                        return acc;
                    }, {});
                    allCustomersRowData.push({ key: i, ...objColumnValue });
                }

                for (let i = 0; i < allCustomersPerDAUOverview.length; i++) {
                    const objColumnValue = allCustomersPerDAUOverview[i].reduce((acc, item) => {
                        acc[item.column] = item.value;
                        return acc;
                    }, {});
                    allCustomersPerDAURowData.push({ key: i, ...objColumnValue });
                }

                // console.log(tmp)
                set_all_customers(allCustomersRowData);
                set_all_customers_per_dau(allCustomersPerDAURowData);
            } catch (error) {
            } finally {
                dispatch(setAppLoading(false));
            }
        }

        Refresh();
    }, [currentTime]);

    function Export() {}
    const items = [
        {
            key: '1',
            label: 'Tất cả khách hàng',
            children: (
                <Table
                    columns={columns}
                    dataSource={all_customers}
                    // pagination={false}
                    scroll={{ x: 'max-content' }}
                />
            ),
        },
        {
            key: '2',
            label: 'Khách hàng active hàng ngày',
            children: (
                <>
                    {/* Hai cột DAU đứng cạnh nhau rất dễ bị hiểu là trùng nhau, trong khi chúng
                        đếm trên hai nguồn log khác nhau ở backend. Nói rõ để không bị coi là
                        số liệu mâu thuẫn. */}
                    <div className="mb-3">
                        <Typography.Text type="secondary">
                            DAU (with Widget) tính cả lượt hoạt động phát sinh từ widget; DAU chỉ
                            tính phiên người dùng mở trong app nên luôn nhỏ hơn
                        </Typography.Text>
                    </div>
                    <Table
                        columns={columnsForPerDAU}
                        dataSource={all_customers_per_dau}
                        // pagination={false}
                        scroll={{ x: 'max-content' }}
                    />
                </>
            ),
        },
    ];
    const onChange = (key) => {
        console.log(key);
    };
    return (
        <div className="container-fluid">
            <div className="card card-body gap-3">
                <div className="flex justify-items-center">
                    <h4 className="align-content-center w-full">CUSTOMERS OVERVIEW</h4>
                    <div className="flex justify-content-end w-full">
                        {/* <Button type="primary">Export</Button> */}
                    </div>
                </div>
                <div className="flex gap-5">
                    <div>
                        <div>
                            <b>Khoảng thời gian</b>
                        </div>
                        {/* <DatePicker
                        defaultValue={[currentTime.startTime]}
                        format="DD/MM/YYYY"
                        onChange={onCalendarChange}
                    /> */}
                        <Form
                            onFinish={(values) => {
                                let obj = {};
                                obj.startTime = dayjs(values.RangePicker[0]).format('DD/MM/YYYY');
                                obj.endTime = dayjs(values.RangePicker[1]).format('DD/MM/YYYY');

                                set_currentTime(obj);
                            }}
                            className="flex gap-3"
                        >
                            <Form.Item name="RangePicker">
                                <RangePicker
                                    // onOpenChange={onOpenChange}
                                    // onCalendarChange={onCalendarChange}
                                    placeholder={['Thời gian bắt đầu', 'Thời gian kết thúc']}
                                    defaultValue={[defaultTime.startTime, defaultTime.endTime]}
                                    format="DD/MM/YYYY"
                                />
                            </Form.Item>
                            <div className="align-content-end">
                                <Form.Item>
                                    <Button
                                        htmlType="submit"
                                        type="primary"
                                        // onClick={() => Refresh()}
                                    >
                                        Áp dụng
                                    </Button>
                                </Form.Item>
                            </div>
                        </Form>
                    </div>
                </div>
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
            </div>
        </div>
    );
}

export default CustormersOverview;
